// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageCard_wrapper__WVNzW"};